import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/response/page.tsx");
